// ─────────────────────────────────────────────────────────────────
// A stricter gate — only users whose database role is "admin" get in.
// Regular logged-in users are redirected to the home page.
//
// IMPORTANT — why the frontend alone is not enough:
// Even if someone tricks the browser into showing the admin page,
// Supabase RLS (Row Level Security) policies on the server side
// will refuse to return any admin data. The frontend gate is just
// a UX convenience; the database is the real lock.
//
// Usage in App.js:
//   <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
//
// ─────────────────────────────────────────────────────────────────

import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

function RequireAdmin({ children }) {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  // Wait for the session check to finish
  if (loading) {
    return (
      <div className="routeGuard__spinner">
        <span className="routeGuard__dot" />
      </div>
    );
  }

  // Not logged in at all → go to the admin login page
  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  // Logged in but not an admin → send them home with no error message
  // (don't hint that an admin area exists)
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  // Confirmed admin → show the dashboard
  return children;
}

export default RequireAdmin;